import { initializeApp } from "firebase/app";
import firebaseConfig from "fireBaseConfig";

const fireBaseApp = initializeApp(firebaseConfig);

export default fireBaseApp;
